import { Spin, Form, Row, Col, Upload, Alert, Collapse, message } from "antd";
import {
  CaretRightOutlined,
  PictureOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { ColorPicker } from "antd5";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormItem,
  InputItem,
  ErrorItem,
  ButtonItem,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import axios from "axios";

const { Panel } = Collapse;
// Tonos de color necesarios para funcionar en el e-commerce
const SHADES = [50, 300, 500, 700, 900];

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class AparienciaConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    formConCambios: false,
  };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  consultarConfiguracion = () => {
    this.setState({ loading: true });

    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionApariencia",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.data) {
          const config = res.data.data;
          const coloresFormateados = {};
          const categorias = ["primario", "secundario", "terciario"];
          const coloresRaw = config.colores || {};

          categorias.forEach((cat) => {
            coloresFormateados[cat] = {};
            if (Array.isArray(coloresRaw[cat])) {
              coloresRaw[cat].forEach((item) => {
                if (item.clave && item.colorHEX) {
                  coloresFormateados[cat][item.clave] = item.colorHEX;
                }
              });
            }
          });

          this.formRef.current.setFieldsValue({
            nombrePagina: config.nombrePagina,
            storeUrl: config.storeUrl,
            logoSvg: config.logoSvg,
            logoHorizontal: config.logoHorizontal,
            logoMovil: config.logoMovil,
            colores: coloresFormateados,
          });
        }
      })
      .catch((err) => {
        console.error("Error cargando config", err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  onFinish = async (values) => {
    this.setState({ loading: true });

    try {
      let logoSvgData = null;
      let logoHorizontalData = null;
      let logoMovilData = null;

      const esArchivo = (fileItem) => {
        return (
          fileItem &&
          fileItem.originFileObj &&
          (fileItem.originFileObj instanceof Blob ||
            fileItem.originFileObj instanceof File)
        );
      };

      // Logo svg
      if (values.logoSvg && values.logoSvg.length > 0) {
        const fileItem = values.logoSvg[0];
        if (esArchivo(fileItem)) {
          const base64 = await getBase64(fileItem.originFileObj);
          logoSvgData = { name: fileItem.name, url: base64 };
        }
      }

      // Logo Horizontal
      if (values.logoHorizontal && values.logoHorizontal.length > 0) {
        const fileItem = values.logoHorizontal[0];
        if (esArchivo(fileItem)) {
          const base64 = await getBase64(fileItem.originFileObj);
          logoHorizontalData = { name: fileItem.name, url: base64 };
        }
      }

      // Logo Movil
      if (values.logoMovil && values.logoMovil.length > 0) {
        const fileItem = values.logoMovil[0];
        if (esArchivo(fileItem)) {
          const base64 = await getBase64(fileItem.originFileObj);
          logoMovilData = { name: fileItem.name, url: base64 };
        }
      }

      const categorias = ["primario", "secundario", "terciario"];
      const coloresObj = {};

      categorias.forEach((cat) => {
        const mapaColores = values.colores ? values.colores[cat] : {};
        coloresObj[cat] = SHADES.map((shade) => {
          const val = mapaColores[shade.toString()];
          let colorHex = "#ffffff";

          if (typeof val === "string") colorHex = val;
          else if (val && typeof val.toHexString === "function")
            colorHex = val.toHexString();

          return { clave: shade.toString(), colorHEX: colorHex };
        });
      });

      const payload = {
        empresaId: this.props.empresaId,
        nombrePagina: values.nombrePagina || "",
        storeUrl: values.storeUrl || "",
        colores: [coloresObj],
        logoSvg: logoSvgData,
        logoHorizontal: logoHorizontalData,
        logoMovil: logoMovilData,
      };

      return axios
        .post(
          "configuracionTiendaOnline/actualizarConfiguracionApariencia",
          payload,
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Se ha modificado la configuracion de la empresa");
            this.setState({ formConCambios: false });
            return true;
          } else if (res.data.success === 1) {
            message.error("No se pudo modificar la configuracion");
            return false;
          } else {
            message.error("Hubo un error y no se modifico la configuracion");
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          message.error("Error al guardar");
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    } catch (error) {
      console.error("Error guardando configuracion:", error);
      message.error("Error al guardar");
      this.setState({ loading: false });
    }
  };

  onFinishFailed(e) {
    ErrorItem(e);
  }

  normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e && e.fileList;
  };

  checkFileSize = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) return false;
    return false;
  };

  normColor = (color) => {
    if (!color) return null;
    if (typeof color === "string") return color;
    if (typeof color.toHexString === "function") return color.toHexString();
    return null;
  };

  renderColorColumn = (title, namePrefix) => {
    return (
      <Col span={8} style={{ padding: "0 10px" }}>
        <Collapse
          defaultActiveKey={["1"]}
          ghost
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
        >
          <Panel
            header={<span style={{ fontWeight: "bold" }}>{title}</span>}
            key="1"
          >
            {SHADES.map((shade) => {
              const isBase = shade === 500;
              return (
                <div
                  key={`${namePrefix}_${shade}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ width: "40%", fontSize: "12px" }}>
                    {isBase ? (
                      <span style={{ fontWeight: "bold", color: "#1890ff" }}>
                        {shade} (Base)
                      </span>
                    ) : (
                      <span style={{ color: "#666" }}>{shade}</span>
                    )}
                  </div>

                  <div style={{ width: "60%" }}>
                    <FormItem
                      name={["colores", namePrefix, shade.toString()]}
                      getValueFromEvent={this.normColor}
                      margin={false}
                      style={{ marginBottom: 0 }}
                    >
                      <ColorPicker
                        disabledAlpha
                        format="hex"
                        size="small"
                        showText
                      />
                    </FormItem>
                  </div>
                </div>
              );
            })}
          </Panel>
        </Collapse>
      </Col>
    );
  };

  tieneCambios = () => {
    return this.state.formConCambios;
  };

  guardarDesdePadre = () => {
    return this.formRef.current
      .validateFields()
      .then((values) => {
        return this.onFinish(values);
      })
      .catch((info) => {
        return false;
      });
  };

  handleValuesChange = (changedValues, allValues) => {
    if (!this.state.formConCambios) {
      this.setState({ formConCambios: true });
    }
  };

  descartarCambios = () => {
    this.setState({ formConCambios: false });
    this.consultarConfiguracion();
  };
  render() {
    const uploadStyle = { width: "100%" };

    return (
      <>
        <Spin spinning={this.state.loading}>
          <Form
            name="aparienciaConfiguracion"
            layout="vertical"
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            ref={this.formRef}
            loading={this.state.loading}
            onValuesChange={this.handleValuesChange}
            initialValues={{
              colores: {
                primario: { 500: "#38bbd1" },
              },
            }}
          >
            <Row gutter={24}>
              <Col span={10}>
                <DynamicCardForm
                  title={"Títulos e imágenes"}
                  style={{
                    margin: "0 auto 12px auto",
                    maxWidth: "98%",
                  }}
                >
                  <FormItem
                    label="Nombre de la página"
                    name="nombrePagina"
                    max={200}
                    margin
                    tooltip="Nombre que aparecerá en la pestaña."
                    required
                  >
                    <InputItem placeholder="Nombre" />
                  </FormItem>

                  <FormItem
                    label="URL de la tienda"
                    name="storeUrl"
                    max={200}
                    margin
                    tooltip="Requerido para poder actualizar el SEO de la página. Ej: https://mitienda.com"
                    rules={[
                      {
                        pattern: /^https?:\/\/.+/,
                        message:
                          "Ingresa una URL válida (debe iniciar con http:// o https://)",
                      },
                    ]}
                  >
                    <InputItem
                      placeholder="https://mitienda.com"
                      prefix={
                        <LinkOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                      }
                    />
                  </FormItem>

                  <FormItem
                    label="Logo SVG"
                    name="logoSvg"
                    valuePropName="fileList"
                    getValueFromEvent={this.normFile}
                    tooltip="Logo vectorizado para poner en la pestaña del sitio."
                    required
                  >
                    <Upload
                      name="logoSvgFile"
                      listType="picture-card"
                      maxCount={1}
                      beforeUpload={this.checkFileSize}
                      accept=".svg,.ico"
                      style={uploadStyle}
                    >
                      <div>
                        <PictureOutlined />
                        <div style={{ marginTop: 8 }}>Subir</div>
                      </div>
                    </Upload>
                  </FormItem>

                  <FormItem
                    label="Logo Horizontal"
                    name="logoHorizontal"
                    valuePropName="fileList"
                    getValueFromEvent={this.normFile}
                    tooltip="Logo horizontal para tamaño de escritorio."
                    required
                  >
                    <Upload
                      name="logoHorFile"
                      listType="picture-card"
                      maxCount={1}
                      beforeUpload={this.checkFileSize}
                      accept="image/*"
                      style={uploadStyle}
                    >
                      <div>
                        <PictureOutlined />
                        <div style={{ marginTop: 8 }}>Subir</div>
                      </div>
                    </Upload>
                  </FormItem>

                  <FormItem
                    label="Logo Móvil"
                    name="logoMovil"
                    valuePropName="fileList"
                    getValueFromEvent={this.normFile}
                    tooltip="Logo para versión móvil."
                    required
                  >
                    <Upload
                      name="logoMovFile"
                      listType="picture-card"
                      maxCount={1}
                      beforeUpload={this.checkFileSize}
                      accept="image/*"
                      style={uploadStyle}
                    >
                      <div>
                        <PictureOutlined />
                        <div style={{ marginTop: 8 }}>Subir</div>
                      </div>
                    </Upload>
                  </FormItem>
                </DynamicCardForm>
              </Col>

              <Col span={14}>
                <DynamicCardForm
                  title={"Paleta de colores"}
                  style={{
                    margin: "0 auto 12px auto",
                    maxWidth: "98%",
                  }}
                >
                  <Row span={24}>
                    <Alert
                      message={
                        "Define la lista de colores que usaremos para tu página de e-commerce."
                      }
                      type={"info"}
                      showIcon
                      style={{ marginTop: 10, marginBottom: 15, width: "100%" }}
                    />
                    <Alert
                      message={
                        "El color marcado como base es el principal que aparecerá cuando se use ese color, los demás deben de ser variaciones del tono para poder diferenciar luces y sombras en la página."
                      }
                      type={"warning"}
                      showIcon
                      style={{ marginBottom: 15, width: "100%" }}
                    />
                  </Row>
                  <Row>
                    {this.renderColorColumn("Primario", "primario")}
                    {this.renderColorColumn("Secundario", "secundario")}
                    {this.renderColorColumn("Terciario", "terciario")}
                  </Row>
                </DynamicCardForm>
              </Col>
            </Row>
            <hr style={{ color: " #afafaf" }}></hr>
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Guardar Configuración
            </ButtonItem>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  AparienciaConfiguracion,
);
